/**
 * 화면 테마 정의.
 *
 * 값(value)은 html[data-theme] 에 그대로 들어가며,
 * 다음 세 곳과 반드시 같아야 한다.
 *  - index.html 의 초기 스크립트(깜빡임 방지)
 *  - src/styles/theme.css 의 html[data-theme='...'] 블록
 *  - 백엔드 MyPageController.AllowedThemes (DB CHECK 제약)
 */
export const THEMES = [
  {
    value: 'white',
    label: '화이트',
    description: '밝고 가벼운 기본 테마',
    // 미리보기 스와치 (껍데기 / 강조 / 본문)
    swatch: ['#ffffff', '#2563eb', '#f5f7fa'],
  },
  {
    value: 'black',
    label: '블랙',
    description: '어두운 곳에서 눈이 편한 흑연 테마',
    swatch: ['#101319', '#4f8dfd', '#15181e'],
  },
  {
    value: 'blue',
    label: '블루',
    description: '짙은 남색 상·좌측바의 정돈된 테마',
    swatch: ['#0e2244', '#1d4ed8', '#ffffff'],
  },
];

export const THEME_VALUES = THEMES.map((t) => t.value);
export const DEFAULT_THEME = 'white';
export const THEME_STORAGE_KEY = 'workncrm.theme';

export const isValidTheme = (value) => THEME_VALUES.includes(value);

/** 저장된 테마를 읽는다. 사생활 보호 모드 등에서 localStorage 접근이 막힐 수 있어 감싼다. */
export const readStoredTheme = () => {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isValidTheme(stored) ? stored : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

/** 저장을 시도하고, 막혀 있으면 조용히 넘어간다. */
export const storeTheme = (value) => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, value);
  } catch {
    /* 이 기기에서는 유지되지 않지만 화면은 이미 바뀐 뒤다 */
  }
};
